import firstNames from './resources/firstNames.json';
import lastNames from './resources/lastNames.json';
import { sample } from 'lodash';

export class Name {
  readonly firstName: string;
  readonly lastName: string;

  constructor() {
    this.firstName = sample(firstNames)!;
    this.lastName = sample(lastNames)!;
  }

  getFirstName(): string {
    return this.firstName;
  }

  getLastName(): string {
    return this.lastName;
  }

  getFullName(): string {
    return `${this.firstName} ${this.lastName}`;
  }
}
